// @ts-ignore
import Lottie from "react-lottie";
import "./Loading.scss";
import lottieIcon from "../../assets/loading-gears.json";

export const LoadingGears = () => {
  return (
    <div className="loading">
      <Lottie
        height={300}
        width={300}
        options={{
          loop: true,
          autoplay: true,
          animationData: lottieIcon,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
      />
    </div>
  );
};
